const GenerateRepairId = (vesselName, displayId) => {
    const vesselPrefix = vesselName?.slice(0, 3).toUpperCase() || "XXX";
    const year = new Date().getFullYear() || "YYYY";
    const formattedDisplayId = String(displayId).padStart(4, "0") || "0000";
  
    return `${vesselPrefix}/RE${formattedDisplayId}/${year}`;
  };
  
  export default GenerateRepairId;